import React, { useEffect, useRef, useState } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import B2RContainer from './Components/B2R/B2RContainer';
import StormwaterProjectContainer from './Components/StormWater/StormwaterProjectContainer';
import Cookies from 'js-cookie';
import HomeContainer from './Components/Home/HomeContainer';
import { handleSignIn } from './Scripts/SignIn';

export default function App() {
    const [isStormwaterAvailable, SetIsStormwaterAvailable] = useState(false);
    const navigate = useNavigate();
    const navigateRef = useRef(navigate);
    const params = useParams();
    const paramsRef = useRef(params);
    useEffect(() => {
        function handleAdfsRedirect() {
            const adfsRedirect = Cookies.get('adfsRedirect');
            if (adfsRedirect) {
                Cookies.remove('adfsRedirect');
                // The following line is to go back to the original location before authenticating, that way clicking back button won't cause problems.
                window.history.pushState({}, "", adfsRedirect);
                navigateRef.current(adfsRedirect);
                //window.location.href = adfsRedirect;
                //window.location.replace(adfsRedirect);
            }
        }

        // Check if we were redirected to b2r/signin.
        if (paramsRef.current['*'] === 'b2r/signin') {
            handleSignIn("/b2r");
        }
        else {
            handleAdfsRedirect();
        }
        
    }, []);

    useEffect(() => {
        function checkErxApiVersion() {
            var url = `Erx/GetApiVersion`;
            var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

            SetIsStormwaterAvailable(false);
            fetch(url, requestInit)
                .then(response => {
                    if (response.ok) { return response.json() }
                    return Promise.reject(response);
                })
                .then(data => {
                    if (data?.assemblyVersion !== undefined && data?.assemblyVersion !== null) {
                        return SetIsStormwaterAvailable(true);
                    }
                    return Promise.reject(new Error('Stormwater is not available.'));
                })
                .catch(e => {
                    // handle error here.
                    SetIsStormwaterAvailable(false);
                    console.log(e.message ?? e);
                });
        }

        checkErxApiVersion();

    }, []);

    let stormwaterRoute = isStormwaterAvailable && (<Route path='/stormwater/:siteId?/*' element={<StormwaterProjectContainer />} />);

    return (<Routes>
        <Route path='/*' element={<HomeContainer />} />
        <Route path='/b2r/*' element={<B2RContainer />} />
        {stormwaterRoute}
    </Routes>);
}
